var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.2505,
    cy: 11.25,
    rx: 11.2505,
    ry: 11.25,
    fill: "#40499D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48535 9.89893H14.1423V10.8417H8.48535V9.89893ZM8.48535 12.2559H14.1423V13.1987H8.48535V12.2559Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9135 6.79461L17.2469 6.12805L15.6677 7.70723C15.4422 7.43537 15.1919 7.18508 14.92 6.95959L16.4993 5.38042L15.8327 4.71387L14.1309 6.4156C13.0542 5.79366 11.8023 5.54443 10.5694 5.70658C9.33662 5.86873 8.19177 6.4332 7.31253 7.31241C6.43328 8.19162 5.86878 9.33642 5.70662 10.5692C5.54446 11.802 5.79371 13.0538 6.41568 14.1305L4.71387 15.8322L5.38045 16.4987L6.95969 14.9196C7.18519 15.1914 7.43549 15.4417 7.70736 15.6672L6.12811 17.2464L6.7947 17.9129L8.49651 16.2112C9.57322 16.8331 10.8251 17.0824 12.0579 16.9202C13.2908 16.7581 14.4356 16.1936 15.3148 15.3144C16.1941 14.4352 16.7586 13.2904 16.9208 12.0576C17.0829 10.8248 16.8337 9.57301 16.2117 8.49634L17.9135 6.79461ZM11.3137 16.0274C10.3813 16.0274 9.46988 15.7509 8.69464 15.2329C7.9194 14.7149 7.31518 13.9787 6.95837 13.1174C6.60157 12.256 6.50821 11.3082 6.69011 10.3938C6.87201 9.47934 7.32099 8.63939 7.98028 7.98013C8.63956 7.32087 9.47954 6.87191 10.394 6.69003C11.3085 6.50814 12.2563 6.60149 13.1177 6.95828C13.9791 7.31506 14.7154 7.91926 15.2334 8.69447C15.7514 9.46967 16.0278 10.3811 16.0278 11.3134C16.0265 12.5632 15.5294 13.7614 14.6456 14.6452C13.7618 15.5289 12.5635 16.026 11.3137 16.0274Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalIcon);
export default __webpack_public_path__ + "static/media/TotalIcon.e285a6f37d6f3b24a36584e9b280c946.svg";
export { ForwardRef as ReactComponent };